import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReviewsRoutingModule } from './reviews-routing.module';
import { MaterialModule } from '../../material/material.module';
import { ReviewsComponent } from './reviews.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReviewsPercentileGroupedByStoreComponent } from './reviews-percentile-grouped-by-store/reviews-percentile-grouped-by-store.component';
import { ReviewOverviewComponent } from './review-overview/review-overview.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    ReviewsComponent,
    ReviewsPercentileGroupedByStoreComponent,
    ReviewOverviewComponent
  ],
  imports: [
    CommonModule,
    ReviewsRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,NgxMatSelectSearchModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class ReviewsModule { }
